import * as React from "react"

import { SEO, ProductList } from "../../components"

const ProductListPage: React.FC<{}> = () => (
  <div>
    <SEO
      article={false}
      title="Get a Hot Deal on Telkom Products"
      description="Shop tablets, routers, notebooks and other mobile devices. Get a contract with a payment plan that speaks to your lifestyle best."
      allowFollow={true}
      allowIndex={true}
    />
    <ProductList />
  </div>
)

export default ProductListPage
